import { BrowserUIReact } from "@jsplumbtoolkit/browser-ui-react";
import { Node } from "@jsplumbtoolkit/core";
import _ from "lodash";

export class CanvasHelpers {
  static canDelete(node: Node) {
    return node.data.type !== "start" && node.data.type !== "routerStart";
  }

  static removeNonExsistingEdges(_node: Node, toolkit: BrowserUIReact) {
    const node = toolkit.getNode(_node.id);
    const sourceEdges = node.getAllSourceEdges();

    const data = { ...node.data };
    sourceEdges.forEach((edge) => {
      const edgeId = edge.source.id.replaceAll("_", ".");

      if (!_.get(data, edgeId)) {
        toolkit.removeEdge(edge);
      }
    });
  }
}
